// extracted by mini-css-extract-plugin
module.exports = {"touchPanY":"ZoomableImage_touchPanY__orSv7","touchNone":"ZoomableImage_touchNone__WB58p"};